module.exports = __webpack_public_path__ + "img/材料力学6_1.4a92af47.jpg";